import React from "react";

var couponSvg = function couponSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.685.588l8.021 8.046a.998.998 0 0 1 0 1.415l-5.679 5.658c-.392.39-1.027.39-1.42 0L.582 7.656A1.99 1.99 0 0 1 0 6.25v-4.25C0 .895.899 0 2.008 0h4.258c.533 0 1.044.212 1.419.588zM3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fillRule: "evenodd"
  }));
};

couponSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var coupon = {
  category: 'icon',
  colorable: true,
  name: 'coupon',
  svg: couponSvg
};